"use strict";

var _defineProperty = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/defineProperty");

var _objectWithoutProperties = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/objectWithoutProperties");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconChatBubbles = void 0;

var React = __importStar(require("react"));

exports.IconChatBubbles = React.forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return React.createElement("svg", _objectSpread(_objectSpread({
    width: "47",
    height: "40",
    viewBox: "0 0 47 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    ref: forwardedRef
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.21581 39.5288L5.42549 33.4891C2.10402 31.4823 0 28.5166 0 25.2089C0 22.0125 1.96229 19.1358 5.09192 17.1372C7.07648 25.4337 16.9405 30.6173 27.0913 30.6173C27.8195 30.6173 28.5422 30.5923 29.2538 30.5423C26.5799 33.8804 21.4738 36.1401 15.6206 36.1401C13.7334 36.1401 11.9212 35.9038 10.2452 35.473L3.67731 39.9312C3.38269 40.123 3.09918 39.8895 3.21592 39.5282L3.21581 39.5288ZM42.512 33.3418L33.5986 27.2965L30.5717 27.869C29.4433 28.0108 28.2787 28.0831 27.0919 28.0831C16.3462 28.0831 7.26625 21.9599 7.26625 14.0415C7.26625 6.12565 16.3469 0 27.0919 0C37.8376 0 46.9147 6.12593 46.9147 14.0415C46.9147 17.2963 45.3665 20.2536 42.815 22.6021L40.3302 24.4532L43.3459 32.6914C43.5321 33.1973 42.9567 33.6447 42.512 33.3418V33.3418ZM22.3078 14.0164C22.3078 12.6739 21.2183 11.5843 19.873 11.5843C18.5306 11.5843 17.441 12.6738 17.441 14.0164C17.441 15.3588 18.5305 16.4512 19.873 16.4512C21.2183 16.4512 22.3078 15.3588 22.3078 14.0164ZM29.5122 14.0164C29.5122 12.6739 28.4227 11.5843 27.0801 11.5843C25.7377 11.5843 24.6453 12.6738 24.6453 14.0164C24.6453 15.3588 25.7377 16.4512 27.0801 16.4512C28.4226 16.4512 29.5122 15.3588 29.5122 14.0164ZM36.7194 14.0164C36.7194 12.6739 35.6299 11.5843 34.2846 11.5843C32.9421 11.5843 31.8525 12.6738 31.8525 14.0164C31.8525 15.3588 32.942 16.4512 34.2846 16.4512C35.6298 16.4512 36.7194 15.3588 36.7194 14.0164Z",
    fill: color
  }));
});